export const StatusCodes = {
  401: "Unauthorized",
  403: "Forbidden",
  500: "There was an issue with the server. Please try again later",
  504: "There was an issue with the server. Please try again later",
  NetworkError: "Network problem. Please try again later",
  "invalid credential": "Incorrect email or password"
};
